module.exports = "/images/sofort.png?872ce97fb4903648a131caa739c0f93a";